export const HELP_CENTER_SECTIONS = [
  {
    slug: "faq",
    title: "FAQ",
    icon: "helpCircle",
    description:
      "A collection of answers to the most frequently asked questions about InsSure. This section helps users quickly resolve common queries related to login, admissions, fees, attendance, permissions, subscriptions, billing, and account management without contacting support.",
    articles: [
      "How do I log in to InsSure?",
      "How do I reset my password?",
      "How are fees and payments managed?",
      "Who can change user permissions?",
      "How do subscriptions and billing work?",
    ],
  },
  {
    slug: "getting-started",
    title: "Getting Started",
    icon: "rocket",
    description:
      "A step-by-step onboarding guide for new institutes. It explains how to create an organization, configure academic sessions, add campuses, set up courses and batches, invite staff, enroll students, configure fees, and begin using the platform successfully.",
    articles: [
      "Create your organization",
      "Configure academic sessions",
      "Add campuses, courses, and batches",
      "Invite staff and enroll students",
      "Configure fees and go live",
    ],
  },
  {
    slug: "user-guides",
    title: "User Guides",
    icon: "bookOpen",
    description:
      "Comprehensive documentation for every module and feature within Inssure. Each guide explains the purpose of a feature, prerequisites, step-by-step instructions, best practices, and expected outcomes, making it easy for administrators, teachers, accountants, counselors, and students to use the system effectively.",
    articles: [
      "Admissions and lead management",
      "Attendance and scheduling",
      "Fees, invoices, and receipts",
      "Roles, permissions, and users",
      "Reports and dashboards",
    ],
  },
  {
    slug: "video-tutorials",
    title: "Video Tutorials",
    icon: "video",
    description:
      "A library of short, practical video demonstrations showing how to perform common tasks. Videos cover module setup, daily operations, advanced configurations, reports, and productivity tips, allowing users to learn visually at their own pace.",
    articles: [
      "Platform overview walkthrough",
      "Daily operations for admins",
      "Marking attendance in batches",
      "Generating fee due reports",
      "Productivity tips for staff",
    ],
  },
  {
    slug: "troubleshooting",
    title: "Troubleshooting",
    icon: "wrench",
    description:
      "Solutions for common issues and error messages users may encounter. This section provides probable causes, step-by-step fixes, diagnostic checks, browser recommendations, connectivity issues, and guidance on when to contact support if the problem persists.",
    articles: [
      "Cannot log in or session expired",
      "Pages not loading or blank screens",
      "Permission denied errors",
      "Browser and connectivity checklist",
      "When to contact support",
    ],
  },
  {
    slug: "release-notes",
    title: "Release Notes",
    icon: "megaphone",
    description:
      "A chronological record of every product update, including new features, enhancements, bug fixes, performance improvements, security updates, deprecated functionality, and any actions users need to take after an update.",
    articles: [
      "Latest release highlights",
      "Feature enhancements",
      "Bug fixes and performance",
      "Security updates",
      "Deprecated functionality notices",
    ],
  },
  {
    slug: "contact-support",
    title: "Contact Support",
    icon: "lifeBuoy",
    description:
      "A dedicated support section where users can raise tickets, report bugs, request new features, track the status of existing requests, access support hours, and find contact information for technical assistance and customer success.",
    articles: [
      "Raise a support ticket",
      "Report a bug",
      "Request a new feature",
      "Track existing requests",
      "Support hours and contact info",
    ],
  },
];

export function getHelpSectionBySlug(slug) {
  return HELP_CENTER_SECTIONS.find((section) => section.slug === slug) || null;
}

export function filterHelpContent(query) {
  const q = query.trim().toLowerCase();
  if (!q) {
    return HELP_CENTER_SECTIONS.map((section) => ({
      ...section,
      matchedArticles: section.articles,
    }));
  }

  return HELP_CENTER_SECTIONS.map((section) => {
    const titleMatch = section.title.toLowerCase().includes(q);
    const descriptionMatch = section.description.toLowerCase().includes(q);
    const matchedArticles = section.articles.filter((article) =>
      article.toLowerCase().includes(q)
    );

    if (!titleMatch && !descriptionMatch && matchedArticles.length === 0) {
      return null;
    }

    return {
      ...section,
      matchedArticles:
        matchedArticles.length > 0 ? matchedArticles : section.articles,
    };
  }).filter(Boolean);
}
